var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatarL = function SvgDefaultAvatarL(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6 55.1h7.6c1.8 0 1.5.7 2.7.7 1.9 0 3.7-4.9 3.7-8.1 0-1.7-.5-2.7-1.4-2.7-.9 0-1.4 1.1-2 3.5-.3 1-.6 2.3-1 2.7-.7.7-3.9 1.1-7.3 1.1H38c-.9-.1-1.1-1.8-1.1-5V32.5c0-3.1.2-4.4.7-4.6 2.2-.1 3.2-.4 3.2-1.3 0-1.2-2.3-1.6-6.3-1.6-3.9 0-6.1.4-6.1 1.6 0 .9.9 1.2 3 1.3.5.2.7 2.2.7 4.6v15.3c0 2.9-.2 4.3-.7 4.5-2.4.1-3.4.4-3.4 1.4 0 1.2 2 1.5 5.6 1.5 1.3-.1 3.1-.1 5-.1z"
  })));
};
export default SvgDefaultAvatarL;